import Model from 'flarum/common/Model';
export default class Webhook extends Model {
  monitorId = (() => Model.attribute('monitorId'))();
  url = (() => Model.attribute('url'))();
  description = (() => Model.attribute('description'))();
  events = (() => Model.attribute('events'))();
  active = (() => Model.attribute('active'))();

  /** Returned only on the create that generates it, never again. */
  secret = (() => Model.attribute('secret'))();
  lastDeliveryAt = (() => Model.attribute('lastDeliveryAt', Model.transformDate))();
  lastStatus = (() => Model.attribute('lastStatus'))();
  lastError = (() => Model.attribute('lastError'))();
  failureCount = (() => Model.attribute('failureCount'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
}
flarum.reg.add('linkrobins-lr-monitoring', 'models/Webhook', Webhook);